import { SelectState } from 'react-stately'

import { createContextAndHook } from '../utils/create-context'

export const [SelectStateContext, useSelectStateContext] =
  createContextAndHook<SelectState<object>>()
